var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_694",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H36V25H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_694)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9999 11.8506C26.3217 15.5634 30.6255 19.2607 34.9781 23C34.9892 22.8312 34.9994 22.7476 34.9994 22.664C35.0001 16.0023 35.0007 9.34078 34.9963 2.67926C34.9963 2.47983 34.9436 2.28058 34.9037 2.00001C30.5631 5.31343 26.2961 8.57085 21.9999 11.8506ZM1.07633 23C5.40154 19.2646 9.69021 15.5607 13.9999 11.8387C9.71102 8.5482 5.44878 5.27792 1.17642 2.00001C1.01091 2.37419 0.929754 22.0944 1.07633 23ZM1.99987 1.00001C2.14782 1.12275 2.21285 1.18018 2.28114 1.2329C7.22182 5.03671 12.1623 8.84073 17.1039 12.643C17.7225 13.1188 18.2967 13.1194 18.9254 12.6426C19.5174 12.1935 20.0986 11.7295 20.6875 11.2765C25.0308 7.9359 29.3753 4.59669 33.7186 1.25572C33.8 1.19297 33.8719 1.11685 33.9999 1.00001H1.99987ZM0.999874 23.9002C1.31443 23.9442 1.51594 23.9969 1.71746 23.9969C12.2411 24.001 22.7648 24.001 33.2886 23.9969C33.489 23.9967 33.6895 23.9428 33.9999 23.898C29.4213 19.8766 24.9384 15.9394 20.4531 12C19.9628 12.3817 19.5066 12.7413 19.046 13.0944C18.0211 13.8805 16.9675 13.8771 15.9476 13.0886C15.4815 12.7278 15.0159 12.3662 14.5464 12.002C10.0461 15.9545 5.57041 19.8858 0.999874 23.9002ZM18.0158 0.00388157C23.1943 0.00388157 28.3728 0.00717204 33.5514 1.04325e-05C34.3357 -0.00115091 35.0203 0.19047 35.5242 0.841596C35.8759 1.29645 36.0012 1.81673 35.9999 2.39141C35.9926 5.88878 35.9964 9.38616 35.9964 12.8837C35.9964 16.1043 35.9972 19.3249 35.9961 22.5457C35.9955 24.1081 35.1193 24.9986 33.572 24.9988C23.1901 25.0004 12.808 25.0004 2.42617 24.9988C0.878307 24.9986 0.000567879 24.1081 0.000377232 22.5473C-0.000385356 15.8544 -0.000194709 9.16144 0.000377232 2.46863C0.000377232 0.880307 0.866487 0.00484935 2.44295 0.00426868C7.63369 0.00291378 12.8248 0.00388157 18.0158 0.00388157Z",
    fill: "#63ABE6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.41b1da636fee1601d542d2022d474d34.svg";
export { ForwardRef as ReactComponent };